import { RouterLink } from '@angular/router';
import { Component, Input } from '@angular/core';
import { LowerCasePipe, NgClass, NgFor, NgIf } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { PaymentsEntity } from '@qwyk/shared-stores/payments';

import { ListItemLoaderComponent } from '../../list-item-loader/list-item-loader.component';
import { PaymentsListViewItemComponent } from '../payments-list-view-item/payments-list-view-item.component';
import { ListItemNothingFoundComponent } from '../../list-item-nothing-found/list-item-nothing-found.component';

@Component({
    standalone: true,
    imports: [
        NgIf,
        NgFor,
        NgClass,
        RouterLink,
        LowerCasePipe,
        TranslateModule,
        FontAwesomeModule,
        ListItemLoaderComponent,
        PaymentsListViewItemComponent,
        ListItemNothingFoundComponent,
    ],
    selector: 'qwyk-payments-list-view',
    templateUrl: './payments-list-view.component.html',
    styleUrls: ['./payments-list-view.component.scss'],
})
export class PaymentsListViewComponent {
    @Input() payments: PaymentsEntity[] = [];
    @Input() loading = false;
    @Input() embedded = false;
    @Input() withInvoiceDetails = false;
    @Input() hideWhileLoading = false;
}
